module.exports = __webpack_public_path__ + "img/image_8.c17932d2.png";